export default {
  home: '首页',
  domestic: '国内展会',
  international: '国际展会',
  exhibitionInfo: '展会资讯',
  conventionCenter: '会展中心',
  cooperate: '展会合作',
  visa: '签证',
  keywordPlaceholder1: '请输入关键字',
  keywordPlaceholder2: '搜索词长度超过 50 字数限制，请删减后重试',
  keywordPlaceholder3: '请输入汉字或字母',
  keyword_error1: '只能搜索汉字、数字或字母',
  keyword_error2: '搜索词长度超过 50 字数限制，请删减后重试',
  top: {
    ticket: '我的门票',
    fair: '我的展会',
    industry: '我的行业',
    leaderboard: '排行榜',
    sitemap: '网站地图',
    signup: '登录/注册',
    order: '我的订单',
    quit: '退出'
  }
}
